import controller from './edit.controller';
import template from './edit.html';

const editMenuComponent = {
  restrict: 'E',
  bindings: {
    mode: '@',
    menu: '=?',
    onCancel: '&'
  },
  controller,
  template
};

export default editMenuComponent;



/** WEBPACK FOOTER **
 ** ./client/app/components/menu/main/edit/edit.component.js
 **/